import {
  LabelBinding,
  RequestDataOfCreateScheduleRequest,
  RequestDataOfOverrideScheduleRequest,
  RequestDataOfSetOverrideConfigurationRequest,
  ResponseDataOfGetOverrideConfigurationResponse,
  ResponseDataOfGetScheduleResponse,
} from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type SetOverrideConfiguration = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  requestBody: RequestDataOfSetOverrideConfigurationRequest;
};
/**
 *
 *
 * @returns void
 */
export function setOverrideConfiguration(
  { businessUnit, label, customerId, accountId, locationId, masterId, requestBody }: SetOverrideConfiguration,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'PUT',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/override/configuration`,
      body: requestBody,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}

type GetOverrideConfiguration = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
};
/**
 *
 *
 * @returns ResponseDataOfGetOverrideConfigurationResponse OK
 */
export function getOverrideConfiguration(
  { businessUnit, label, customerId, accountId, locationId, masterId }: GetOverrideConfiguration,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetOverrideConfigurationResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/override/configuration`,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
        501: 'Not Implemented',
      },
    },
    requestConfig,
  );
}

type OverrideSchedule = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  requestBody: RequestDataOfOverrideScheduleRequest;
};
/**
 *
 *
 * @returns void
 */
export function overrideSchedule(
  { businessUnit, label, customerId, accountId, locationId, masterId, requestBody }: OverrideSchedule,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/schedule/override`,
      body: requestBody,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}

type GetSchedule = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
};
/**
 *
 *
 * @returns ResponseDataOfGetScheduleResponse OK
 */
export function getSchedule(
  { businessUnit, label, customerId, accountId, locationId, masterId }: GetSchedule,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataOfGetScheduleResponse> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/schedule`,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
        501: 'Not Implemented',
      },
    },
    requestConfig,
  );
}

type CreateSchedule = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  requestBody: RequestDataOfCreateScheduleRequest;
};
/**
 *
 *
 * @returns any Created
 */
export function createSchedule(
  { businessUnit, label, customerId, accountId, locationId, masterId, requestBody }: CreateSchedule,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'POST',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/schedule`,
      body: requestBody,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
        501: 'Not Implemented',
      },
    },
    requestConfig,
  );
}

type DeleteOverrideByTemperature = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
};
/**
 *
 *
 * @returns void
 */
export function deleteOverrideByTemperature(
  { businessUnit, label, customerId, accountId, locationId, masterId }: DeleteOverrideByTemperature,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'DELETE',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/schedule/override/temperature`,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}

type DeleteOverrideByScene = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  sceneId: string;
};
/**
 *
 *
 * @returns void
 */
export function deleteOverrideByScene(
  { businessUnit, label, customerId, accountId, locationId, masterId, sceneId }: DeleteOverrideByScene,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'DELETE',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/schedule/override/scene/${sceneId}`,
      errors: {
        400: 'Bad Request',
        403: 'Forbidden',
        404: 'Not Found',
        412: 'Precondition Failed',
        500: 'Internal Server Error',
      },
    },
    requestConfig,
  );
}
